document.addEventListener("DOMContentLoaded", function () {
  const gridSlider = document.querySelectorAll("[data-grid-slider]");
  if (gridSlider) {
    gridSlider.forEach((slider) => {
      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      const swiper = new Swiper(slider, {
        slidesPerView: 1.5,
        slidesPerGroup: 1,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
        pagination: {
          el: ".custom-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: isDesktop ? ".swiper-button-next-desktop" : ".swiper-button-next",
          prevEl: isDesktop ? ".swiper-button-prev-desktop" : ".swiper-button-prev",
        },
      });

      window.addEventListener("resize", () => {
        const isNowDesktop = window.matchMedia("(min-width: 1024px)").matches;
        const newNextEl = isNowDesktop ? ".swiper-button-next-desktop" : ".swiper-button-next";
        const newPrevEl = isNowDesktop ? ".swiper-button-prev-desktop" : ".swiper-button-prev";

        swiper.navigation.destroy();

        swiper.params.navigation.nextEl = newNextEl;
        swiper.params.navigation.prevEl = newPrevEl;

        swiper.navigation.init();
        swiper.navigation.update();
      });
    });
  }
});
